<app-hero [title]="'Artikel'"></app-hero>
<section id="blog-posts" class="blog-posts section">
  <div class="container">
    <div class="row gy-4">
      <div class="col-lg-4" *ngFor="let article of articles">
        <article class="position-relative h-100">
          <div class="post-img position-relative overflow-hidden">
            <img *ngIf="article.coverUrl" [src]="article.coverUrl" class="img-fluid" alt="{{ article.title }}">
            <span class="post-date">{{ article.publishedAt?.toDate() | date:'d. MMMM' }}</span>
          </div>
          <div class="post-content d-flex flex-column">
            <h3 class="post-title">{{ article.title }}</h3>
            <div class="meta d-flex align-items-center">
              <div class="d-flex align-items-center">
                <i class="bi bi-person"></i> <span class="ps-2">{{ article.authorName || 'Unbekannt' }}</span>
              </div>
              <span class="px-3 text-black-50">/</span>
              <div class="d-flex align-items-center">
                <i class="bi bi-folder2"></i> <span class="ps-2">{{ article.category || 'Ohne Kategorie' }}</span>
              </div>
            </div>
            <p>
              {{getPlainContent(article.content)}}
            </p>
            <hr>
            <a [routerLink]="['/Article', article.id]" class="readmore stretched-link">
              <span>Weiterlesen</span><i class="bi bi-arrow-right"></i>
            </a>
          </div>
        </article>
      </div><!-- End post list item -->
    </div>

    <div *ngIf="showSpinner" style="display: flex; align-items: center; justify-content: center;">
      <td colspan="7">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Lädt...</span>
        </div>
      </td>
    </div>
  </div>
</section><!-- /Blog Posts Section -->